import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { ButtonV2 } from '@zola/zola-ui';

import { browserHistory } from 'react-router';
import { getUserContext, updateUserStatus } from '../../../actions/UserActions';
import { fetchWeddingAccount } from '../../../actions/WeddingActions';
import { fetchRegistry } from '../../../actions/RegistryActions';
import { showModal } from '../../../actions/ModalActions';
import { updateSlug } from '../../../actions/OnboardActions';
import * as NotificationService from '../../../actions/NotificationActions';
import EditSlug from './EditSlug';
import PublicUrl from './PublicUrl';

import '../../../stylesheets/pages/settings/Settings.less';

class UrlContainer extends Component {
  constructor(props) {
    super(props);

    const { userContext } = this.props;
    const slug = userContext.user_role_account_weddings && userContext.user_role_account_weddings[0].slug;
    this.state = {
      slug,
      updated: false,
      showTooltip: false
    };

    this.liveUpdateSlug = this.liveUpdateSlug.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdateSlug = this.handleUpdateSlug.bind(this);
    this.toggleEditSlugTooltip = this.toggleEditSlugTooltip.bind(this);
  }

  componentDidMount() {
    const { handleGetUserContext, handleFetchWeddingAccount, handleFetchRegistryAccount } = this.props;
    handleGetUserContext().then(() => {
      const { userContext } = this.props;
      if (userContext.has_wedding_account) {
        handleFetchWeddingAccount();
      }
      if (userContext.has_registry) {
        handleFetchRegistryAccount();
      }
    });
  }

  getWebsiteDetails() {
    const { weddingAccount } = this.props;
    const { slug } = this.state;
    const websiteUrl = `${window.location.host}/wedding`;
    const websiteCta = weddingAccount.published ? 'View Website ›' : 'Manage Website ›';
    const websiteCtaLink = weddingAccount.published ? `/wedding/${slug}` : '/wedding/manage/website/manage';
    const websiteMessage = weddingAccount.published ? 'Guests can see your wedding website.' : 'Guests cannot see your wedding website.';

    return {
      websiteUrl,
      websiteCta,
      websiteCtaLink,
      websiteMessage
    };
  }

  getRegistryDetails() {
    const { registryAccount } = this.props;
    const { slug } = this.state;
    const registryUrl = `${window.location.host}/registry`;
    const registryCta = registryAccount.is_public ? 'View Registry ›' : 'Manage Registry ›';
    const registryCtaLink = registryAccount.is_public ? `/registry/${slug}?preview=true` : `/registry/${slug}/edit`;
    const registryMessage = registryAccount.is_public ? 'Guests can visit and see your registry.' : 'Guests cannot visit or shop your registry.';

    return {
      registryUrl,
      registryCta,
      registryCtaLink,
      registryMessage
    };
  }

  liveUpdateSlug(slug) {
    this.setState({
      slug,
      showTooltip: true
    });
  }

  // showTooltip & toggleEditSlugTooltip is passed to `EditSlug` because `UrlContainer` will hide the tooltip upon editing the slug
  toggleEditSlugTooltip() {
    const { showTooltip } = this.state;
    this.setState({
      showTooltip: !showTooltip
    });
  }

  hideEditSlugTooltip() {
    const showTooltip = false;
    this.setState({
      showTooltip
    });
  }

  handleUpdateSlug() {
    const {
      showSuccessNotification,
      showErrorNotification,
      saveSlug,
      userContext,
      handleUpdateUserStatus
    } = this.props;
    const { slug } = this.state;
    const accountId = userContext.user_role_account_weddings[0].account_id;
    const successMessage = 'Your URL has been updated!';
    const errorMessage = 'There was a problem in updating your slug.';

    handleUpdateUserStatus().then((userStatus) => {
      if (userStatus.payload.status !== 'IDLE') {
        saveSlug({ slug, accountId }).then((response) => {
          if (response.status === 'success') {
            showSuccessNotification(successMessage);
            this.hideEditSlugTooltip();
            this.setState({
              updated: true
            });
            setTimeout(() => {
              this.setState({
                updated: false
              });
            }, 3000);
          } else {
            showErrorNotification(response.message || errorMessage);
          }
        }).catch((error) => {
          console.log('error', error);
        });
      } else {
        browserHistory.push({ pathname: '/wedding/login', state: { referralPage: window.location.pathname } });
      }
    });
  }

  handleSubmit() {
    const {
      registryAccount,
      weddingAccount,
      openAcknowledgeUpdateModal
    } = this.props;

    if (registryAccount.is_public || weddingAccount.published) {
      openAcknowledgeUpdateModal(this.handleUpdateSlug);
    } else {
      this.handleUpdateSlug();
    }
  }

  // TODO: first check to make sure this is a user of zola (maybe add the check in the routing once we decide on route)
  render() {
    const {
      userContext,
      weddingAccount,
      openCustomDomainModal
    } = this.props;

    const {
      slug,
      updated,
      showTooltip
    } = this.state;

    const hasWeddingAccount = !!weddingAccount.account_id;
    const hasRegistryAccount = userContext.registry_ids && userContext.registry_ids.length > 0;

    const websiteDetails = this.getWebsiteDetails();
    const registryDetails = this.getRegistryDetails();

    return (
      <div className="settings-url__container">
        <Helmet defaultTitle="Your Url" />
        <h1 className="settings-page-header">Your URL{hasWeddingAccount && hasRegistryAccount && <span>s</span>}</h1>
        <div className="settings-url__container-section">
          <EditSlug
            originalSlug={userContext.user_role_account_weddings && userContext.user_role_account_weddings[0].slug}
            userContext={userContext}
            updated={updated}
            onSubmit={this.handleSubmit}
            liveUpdateSlug={this.liveUpdateSlug}
            hasWedding={hasWeddingAccount}
            hasRegistry={hasRegistryAccount}
            showTooltip={showTooltip}
            toggleEditSlugTooltip={this.toggleEditSlugTooltip}
          />
        </div>
        <div className="settings-url__container-section">
          {
            hasWeddingAccount
              && (
              <PublicUrl
                title="website url"
                slug={slug}
                publicUrl={websiteDetails.websiteUrl}
                message={websiteDetails.websiteMessage}
                cta={websiteDetails.websiteCta}
                ctaLink={websiteDetails.websiteCtaLink}
              />
              )
          }
          {
            hasRegistryAccount
              && (
              <PublicUrl
                title="registry url"
                slug={slug}
                publicUrl={registryDetails.registryUrl}
                message={registryDetails.registryMessage}
                cta={registryDetails.registryCta}
                ctaLink={registryDetails.registryCtaLink}
              />
              )
          }
        </div>
        <div className="settings-url__container-section">
          <div className="custom-domain__container">
            <h2>Purchase or Connect a Custom Domain</h2>
            <p>(ie. jackandjill.com)</p>
            <ButtonV2
              variant="secondary"
              onClick={openCustomDomainModal}
            >
              Find Out How
            </ButtonV2>
          </div>
        </div>
      </div>
    );
  }
}

UrlContainer.propTypes = {
  userContext: PropTypes.shape({}).isRequired,
  handleGetUserContext: PropTypes.func,
  handleFetchWeddingAccount: PropTypes.func,
  handleFetchRegistryAccount: PropTypes.func,
  weddingAccount: PropTypes.shape({}),
  registryAccount: PropTypes.shape({}),
  openCustomDomainModal: PropTypes.func,
  openAcknowledgeUpdateModal: PropTypes.func,
  showSuccessNotification: PropTypes.func,
  showErrorNotification: PropTypes.func,
  handleUpdateUserStatus: PropTypes.func,
  saveSlug: PropTypes.func
};


const mapStateToProps = state => ({
  userContext: state.user.userContext,
  weddingAccount: state.wedding.account,
  registryAccount: state.registry
});

const mapDispatchToProps = dispatch => ({
  handleGetUserContext: () => dispatch(getUserContext()),
  handleFetchWeddingAccount: () => dispatch(fetchWeddingAccount()),
  handleFetchRegistryAccount: () => dispatch(fetchRegistry()),
  openCustomDomainModal: () => dispatch(showModal('CUSTOM_DOMAIN_MODAL', {}, { size: 'md' })),
  openAcknowledgeUpdateModal: handleUpdateSlug => dispatch(showModal('ACKNOWLEDGE_UPDATE_MODAL', { updateSlug: handleUpdateSlug }, { size: 'md' })),
  showSuccessNotification: message => dispatch(NotificationService.confirmation({ message })),
  showErrorNotification: message => dispatch(NotificationService.error({ message })),
  saveSlug: slug => dispatch(updateSlug(slug)),
  handleUpdateUserStatus: () => dispatch(updateUserStatus())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UrlContainer);



// WEBPACK FOOTER //
// ./src/components/settings/url/UrlContainer.jsx